import gql from "graphql-tag";

const query = gql`
  query EventType($eventTypeId: ID) {
    eventType(eventTypeId: $eventTypeId) {
      isSportEvent
    }
  }
`;

export default eventTypeId => ({
  query,
  skip: !eventTypeId,
  variables: { eventTypeId },
});
